<template>
  <div class="row align-items-center rows-products" role="list" aria-label="Produktgitter">
    <div
      v-for="(item, index) in products"
      :key="item.id"
      class="col-xl-3 col-lg-4 col-md-6 col-6"
      role="listitem"
      :aria-label="item.name || 'Produkt'"
    >
      <div class="product_grid card b-0">
        <div
          v-if="item.tag"
          :class="['badge', badgeClass(item.tag), 'text-white', 'position-absolute', 'ft-regular', 'ab-left', 'text-upper']"
          :aria-label="item.tag == 'Sold' ? 'Solgt' : item.tag"
        >
          {{ item.tag == 'Sold' ? 'Solgt' : item.tag }}
        </div>

        <div class="card-body p-0 d-flex flex-column">
          <div class="shop_thumb position-relative">
            <router-link
              class="d-block overflow-hidden"
              :to="`/produkt/${item.name
                .toLowerCase()
                .replace(/[æÆ]/g, 'ae')
                .replace(/[øØ]/g, 'oe')
                .replace(/[åÅ]/g, 'aa')
                .replace(/[^a-z0-9]+/g, '-')
                .replace(/^-+|-+$/g, '')}-${item.id}`"
              :aria-label="(item.name ? item.name + ' detaljer' : 'Se produkt')"
              :title="item.name || 'Se produkt'"
            >
            <img
              class="img-fluid w-100 object-fit-cover rounded"
              style="aspect-ratio: 1/1; transition: transform 0.4s ease;"
              :src="item.image1 || noProductImage"
              :alt="item.imageAlt || (item.name ? `${item.name} – produktbillede` : 'Produktbillede')"
              :title="item.name || 'Produktbillede'"
              loading="lazy"
              decoding="async"
              :fetchpriority="index === 0 ? 'high' : 'auto'"
              onmouseover="this.style.transform='scale(1.05)'"
              onmouseout="this.style.transform='scale(1)'"
            />

            </router-link>
          </div>
        </div>

        <div class="card-footers b-0 pt-3 px-2 bg-white text-center">
          <h2 class="fw-normal fs-md mb-1 lh-sm text-truncate">
            <router-link
                :to="`/produkt/${item.name
                .toLowerCase()
                .replace(/[æÆ]/g, 'ae')
                .replace(/[øØ]/g, 'oe')
                .replace(/[åÅ]/g, 'aa')
                .replace(/[^a-z0-9]+/g, '-')
                .replace(/^-+|-+$/g, '')}-${item.id}`"
              v-html="item.name"
              :aria-label="(item.name ? item.name + ' detaljer' : 'Se produkt')"
              :title="item.name || 'Se produkt'"
            ></router-link>
          </h2>
          <div class="elis_rty">
            <span v-if="!(item?.tag === 'Sold' && item?.artistSoldOutHidePrice === 1)" class="fw-medium fs-md text-dark" :aria-label="(item.price ? item.price + ' kroner' : 'Pris ikke angivet')">{{ item.price }} kr.</span>
            <span v-else class="fw-medium fs-md text-muted" aria-label="Solgt produkt">Solgt produkt</span>
          </div>
          <router-link
              :to="'/kunstner/' + item?.artistSubdomain"
              :aria-label="'Se profilside for ' + (data?.artistName || 'kunstner')"
              :title="'Profilside for ' + (item?.artistName || 'kunstner')"
              class="text-muted"
          >
            <span class="d-block text-truncate" v-html="item.artistName" aria-label="Kunstnernavn"></span>
          </router-link>
        </div>
      </div>
    </div>

    <div v-if="loading" class="col-12 text-center py-5" aria-live="polite" aria-busy="true">
      <div
        class="spinner-border text-dark"
        role="status"
        style="width: 3rem; height: 3rem;"
      >
        <span class="visually-hidden">Indlæser...</span>
      </div>
    </div>

    <div v-if="!loading && products.length === 0" class="col-12 text-center py-5" aria-live="polite">
      <p>Ingen produkter fundet.</p>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from "vue";
import noProductImage from "@/assets/img/no_product_image.webp";

defineProps({
  products: { type: Array, required: true },
  loading: { type: Boolean, default: false }
});

const badgeClass = (tag) => {
  switch (tag) {
    case "Sale":
      return "bg-sale";
    case "New":
      return "bg-new";
    case "Hot":
      return "bg-hot";
    case "Sold":
      return "bg-sold";
    default:
      return "bg-dark";
  }
};
</script>